/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import React from 'react';
import { Col, Row } from 'reactstrap';
import CreateUserForm from './CreateUserForm/index.js';

const CreateUser = () => (
  <div>
    <Row>
      <Col md="12">
        <h1>Create User</h1>
      </Col>
    </Row>
    <Row>
      <Col md="12">
        <CreateUserForm />
      </Col>
    </Row>
  </div>
);

export default CreateUser;
